<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; display: flex"
      >
        <LoadingMDL />
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import LoadingMDL from '@/components/loading/LoadingMDL';

export default {
  name: 'AuthCallBack',
  components: {
    LoadingMDL,
  },
  data() {
    return {
      data: [],
      loading: true,
    };
  },

  mounted() {
    this.getParamsAndProcess();
  },
  computed: {},
  watch: {},
  methods: {
    async getParamsAndProcess() {
      try {
        console.log('helloworld');

        this.loading = true;
        const {code} = this.$route.query;
        if (!code) {
          console.log('code not detected');
          this.$router.push('/homepage');
        } else {
          console.log('code detected');
          await this.$store.dispatch('auth/ssoLogin', {code: code});

          this.$router.push('/homepage');
        }
      } catch (error) {
        console.log(error, 'getparamsadn prox');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
